const ACTIVE_FEATURE_FLAGS: string[] = [];

// image widths within the lead media.
const LEAD_MEDIA_SMALL_WIDTH = 375;
const LEAD_MEDIA_MEDIUM_WIDTH = 567;
const LEAD_MEDIA_LARGE_WIDTH = 700;
const LEAD_MEDIA_ASPECT_HEIGHT = 9;
const LEAD_MEDIA_ASPECT_WIDTH = 16;

// Screen widths
const LARGE_SCREEN_WIDTH_MIN = 1200;
const MEDIUM_SCREEN_WIDTH_MAX = 1199;
const MEDIUM_SCREEN_WIDTH_MIN = 992;
const SMALL_SCREEN_WIDTH_MAX = 991;
const SMALL_SCREEN_WIDTH_MIN = 768;
const EXTRA_SMALL_SCREEN_WIDTH_MAX = 767;

const FIXED_NAV_TABLET_HEIGHT = 64;

const JOB_ALERT_EXCLUDED_COMPANY_NAMES = ["squarespace"];
const JOB_ALERT_EXCLUDED_TAGS = ["anti-racism"];
const NEWSLETTER_EXCLUDED_LANDING_PAGES = [
    "employer-resources",
];
const NEWSLETTER_EXCLUDED_TAGS = [
    "employer-resources"
];
const NEWSLETTER_EXCLUDED_PRIMARY_TOPICS = [
    "employer-resources"
];
const JOB_ALERT_EXCLUDED_LANDING_PAGES = [
    "anti-racism-at-work",
    "work-relationships",
    "job-offer",
    "management",
    "interviewing",
    "break-room",
    "money",
    "work-life-balance",
    "employer-resources",
    "changing-jobs",
    "career-stories"
];
const JOB_ALERT_EXCLUDED_PRIMARY_TOPICS = [
    "anti-racism-at-work",
    "work-relationships",
    "job-offer",
    "management",
    "interviewing",
    "break-room",
    "money",
    "work-life-balance",
    "employer-resources",
    "changing-jobs",
    "career-stories"
];

export {
    ACTIVE_FEATURE_FLAGS,
    LEAD_MEDIA_SMALL_WIDTH,
    LEAD_MEDIA_MEDIUM_WIDTH,
    LEAD_MEDIA_LARGE_WIDTH,
    LEAD_MEDIA_ASPECT_HEIGHT,
    LEAD_MEDIA_ASPECT_WIDTH,
    LARGE_SCREEN_WIDTH_MIN,
    MEDIUM_SCREEN_WIDTH_MAX,
    MEDIUM_SCREEN_WIDTH_MIN,
    SMALL_SCREEN_WIDTH_MAX,
    SMALL_SCREEN_WIDTH_MIN,
    EXTRA_SMALL_SCREEN_WIDTH_MAX,
    FIXED_NAV_TABLET_HEIGHT,
    JOB_ALERT_EXCLUDED_COMPANY_NAMES,
    JOB_ALERT_EXCLUDED_TAGS,
    JOB_ALERT_EXCLUDED_LANDING_PAGES,
    JOB_ALERT_EXCLUDED_PRIMARY_TOPICS,
    NEWSLETTER_EXCLUDED_LANDING_PAGES,
    NEWSLETTER_EXCLUDED_PRIMARY_TOPICS,
    NEWSLETTER_EXCLUDED_TAGS
};
